__webpack_require__.p = "/Star-Wars-React/";